import React from 'react'
import styles from './styles.module.scss'

interface Part {
  readonly label: string
  readonly color: string
}

interface Props {
  parts: Part[]
}

export function ColourLegend({ parts }: Props) {
  return (
    <div className={styles.colorLegend}>
      {parts.map(value => (
        <div className={styles.colorLegendItem} key={value.label}>
          <div
            className={`${styles.colorChip}`}
            style={{ backgroundColor: value.color }}
          />
          <div>{value.label}</div>
        </div>
      ))}
    </div>
  )
}
